export function vapidPublicKey(): string {
  const key = import.meta.env.VITE_VAPID_PUBLIC_KEY as string | undefined;
  if (!key) {
    throw new Error('VITE_VAPID_PUBLIC_KEY is not set');
  }
  return key;
}

export function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  const output = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    output[i] = rawData.charCodeAt(i);
  }
  return output;
}

/**
 * Fetches the push-only service worker registration, registering it if it
 * doesn't exist yet, and waits until it is active. On a first install the
 * registration can still be `installing` — subscribing before it settles
 * makes `pushManager.subscribe` reject (seen on iPhone/Nest).
 */
export async function ensureServiceWorkerRegistration(): Promise<ServiceWorkerRegistration> {
  await (
    (await navigator.serviceWorker.getRegistration('/sw-push.js')) ??
    (await navigator.serviceWorker.register('/sw-push.js'))
  );
  return navigator.serviceWorker.ready;
}
